import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, LOCALE_ID } from '@angular/core';
import { provideRouter, withComponentInputBinding, TitleStrategy, withNavigationErrorHandler, withInMemoryScrolling } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DateAdapter, provideNativeDateAdapter } from '@angular/material/core';
import { LocalDateAdapter } from './core/utils/local-date-adapter';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import { AppTitleStrategy } from './core/router/app-title-strategy';

import { routes } from './app.routes';

registerLocaleData(localeEsAr);

/**
 * Tras un deploy, una pestaña abierta con el build anterior pide chunks que ya no
 * existen y el servidor devuelve index.html. Se recarga una vez para tomar el build
 * nuevo; la marca en sessionStorage evita un loop si el chunk falta de verdad.
 */
function reloadOnStaleChunk(error: unknown): void {
  const message = error instanceof Error ? error.message : String(error ?? '');
  if (!/Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message)) {
    return;
  }
  const key = 'kf-stale-chunk-reload';
  try {
    const last = Number(sessionStorage.getItem(key) ?? 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    // sessionStorage no disponible: recargar igual
  }
  window.location.reload();
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'es-AR' },
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    // 'YYYY-MM-DD' se lee como día local (si no, los selectores muestran un día menos en Argentina)
    { provide: DateAdapter, useClass: LocalDateAdapter },
    provideRouter(
      routes,
      withComponentInputBinding(),
      withNavigationErrorHandler((e) => {
        console.error('Error de Navegación:', e);
        reloadOnStaleChunk(e.error);
      }),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })
    ),
    { provide: TitleStrategy, useClass: AppTitleStrategy }
  ]
};
